module.exports = __webpack_public_path__ + "static/media/apartment9.45aa3dee.jpg";